<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Absensi
        </li>
        <li class="breadcrumb-item">
          <a href="#/absen-bulan-input-final">Input Absensi</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/absen-bulan-import">Import Absensi</a>
        </li>
      </ol>
    </nav>

    <h5 class="content-block">
      Daftar Absensi
      <span>
        <DxButton
          icon="refresh"
          @click="resetFilter()"
          text="Hilangkan filter"
          type="danger"
          styling-mode="outlined"
          style="float: right"
        ></DxButton>
      </span>

      <span>
        <DxButton
          v-if="buttonCan('absensi-create')"
          icon="edit"
          @click="settingLiburDialog()"
          text="Setting Hari Libur Pegawai"
          type="default"
          style="float: right"
          styling-mode="outlined"
        ></DxButton>
      </span>
    </h5>
    <DxPopup
      :visible="popupLoadingVisible"
      title="Sinkronisasi gaji dengan absensi..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>

    <DxPopup
      v-if="settingLiburSource"
      :visible="popupSettingLiburVisible"
      title="Konfigurasi Setting Libur Pegawai"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="500"
      :width="550"
    >
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">Periode Absensi</div>
          <div class="dx-field-value">
            <DxDateBox
              :show-clear-button="true"
              :use-mask-behavior="true"
              :input-attr="{ 'aria-label': 'Date' }"
              type="date"
              displayFormat="monthAndYear"
              :calendar-options="calendarMonthYear"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              v-model="settingLiburSource.tgl"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxDateBox>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">
          Jumlah Hari Libur Per Status Pegawai
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Direksi</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Hari Libur Direksi"
              v-model="settingLiburSource.direksi"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Pegawai Tetap</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Hari Libur Pegawai Tetap"
              v-model="settingLiburSource.tetap"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Calon Pegawai</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Hari Libur Calon Pegawai"
              v-model="settingLiburSource.capeg"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Honor</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Hari Libur Pekerja Honor"
              v-model="settingLiburSource.honor"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">Kontrak</div>
          <div class="dx-field-value">
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Hari Libur Pekerja Kontrak"
              v-model="settingLiburSource.kontrak"
            >
              <DxValidator>
                <DxNumericRule message="Data adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptions"
      />
    </DxPopup>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @editing-start="editingStart"
          @option-changed="onPageChanged($event, 'dataGrid')"
          @row-updating="onRowUpdating($event, 'dataGrid')"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :scrolling="{ mode: 'virtual' }"
        >
          <DxScrolling mode="virtual" row-rendering-mode="virtual" />
          <DxFilterRow :visible="true" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="can('absensi-update')"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="created_at"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <DxColumn
            caption="pegawaiID"
            data-field="pegawai_id"
            data-type="number"
            :visible="false"
          />
          <!-- <DxColumn
            caption="#"
            data-field="id"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          /> -->

          <DxColumn
            class="noteditable"
            data-field="gajis.status_gaji"
            data-type="boolean"
            caption="Status Gaji"
            cell-template="statusTemplate"
            :fixed="true"
            fixed-position="left"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusGajiSource"
            />
          </DxColumn>

          <template #statusTemplate="{ data }">
            <!-- {{ formatStatusGaji(data.text) }} -->
            <DxButton
              :icon="formatStatusGaji('icon', { data })"
              :type="formatStatusGaji('type', { data })"
            />
          </template>

          <!-- <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template> -->
          <template #periodeAbsenTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>
          <!-- <DxColumn
            data-type="number"
            data-field="pegawai_id"
            caption="PEGAWAI ID"
            :fixed="true"
            fixed-position="left"
            :visible="false"
          >
          </DxColumn> -->
          <DxColumn
            data-type="string"
            data-field="pegawai.nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="pegawai.nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>
          <DxColumn
            data-field="periode_absen"
            caption="Periode Absen"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            :filter-operations="filterOperations"
            sort-order="desc"
            cell-template="periodeAbsenTemplate"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaan.cabang_id"
            caption="Cabang"
            data-type="number"
          >
            <DxLookup
              :data-source="cabangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.unit_id"
            caption="Unit"
            data-type="number"
          >
            <DxLookup
              :data-source="unitSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaan.pegawai_status_id"
            caption="Status"
            data-type="number"
          >
            <DxLookup
              :data-source="pegawaiStatusSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaan.bagian_id"
            caption="Bagian"
            data-type="number"
          >
            <DxLookup
              :data-source="bagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.sub_bagian_id"
            caption="Sub Bagian"
            data-type="number"
          >
            <DxLookup
              :data-source="subBagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.bidang_id"
            caption="Bidang"
            data-type="number"
          >
            <DxLookup
              :data-source="bidangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.sub_bidang_id"
            caption="Sub Bidang"
            data-type="number"
          >
            <DxLookup
              :data-source="subBidangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaan.seksi_id"
            caption="Seksi"
            data-type="number"
          >
            <DxLookup
              :data-source="seksiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="hadir"
            caption="Hadir"
            data-type="number"
          ></DxColumn>

          <DxColumn
            data-field="sakit"
            data-type="number"
            caption="Sakit"
            :set-cell-value="setCellValueSakit"
          ></DxColumn>
          <DxColumn
            data-field="ijin"
            data-type="number"
            caption="Ijin"
            :set-cell-value="setCellValueIjin"
          ></DxColumn>
          <DxColumn
            data-field="alpa"
            data-type="number"
            caption="Alpa"
            :set-cell-value="setCellValueAlpa"
          ></DxColumn>
          <DxColumn
            data-field="cuti"
            data-type="number"
            caption="Cuti"
            :set-cell-value="setCellValueCuti"
          ></DxColumn>
          <DxColumn
            data-field="libur"
            data-type="number"
            caption="Libur"
            :set-cell-value="setCellValueLibur"
          ></DxColumn>
          <DxColumn
            data-field="tidak_hadir"
            data-type="number"
            caption="Tdk Hadir"
            css-class="cell-highlighted"
          ></DxColumn>
          <DxSummary>
            <DxTotalItem
              column="id"
              summary-type="count"
              value-format="#,##0"
            />
            <DxTotalItem
              column="hadir"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="sakit"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="ijin"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="alpa"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="cuti"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="libur"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="tidak_hadir"
              summary-type="sum"
              value-format="#,##0"
            />
          </DxSummary>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import { confirm } from "devextreme/ui/dialog";
import auth from "@/auth";
import api from "@/api";
import can from "@/haspermission";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import axios from "axios";
import notify from "devextreme/ui/notify";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
} from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
// import DxSelectBox from "devextreme-vue/select-box";
// import ODataStore from "devextreme/data/odata/store";
import { DateTime } from "luxon";
// import DataSource from "devextreme/data/data_source";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxScrolling,
  // DxItem,
  // DxSelection,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];
const ds = new DataSource({
  store: new ODataStore({
    url: `${ODATA_BASE_URL}/AbsenBulans`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      // e.params.$orderby = "pegawai_id asc";
      if (typeof e.params.$orderby == "undefined") {
        e.params.$orderby = "pegawai_id asc";
      } else {
        var newSortString = _(e.params.$orderby.split(","))
          .filter((criteria) => criteria.trim() !== "id")
          .join(",");
        if (newSortString === "")
          e.params.$orderby = newSortString + "pegawai_id asc";
        else e.params.$orderby = newSortString + ",pegawai_id asc";
      }

      if (typeof e.params.$filter === "undefined") {
        // e.params.$filter =
        //   "(periode_absen ge '" +
        //   currentDate +
        //   "') and (periode_absen lt '" +
        //   nextDate +
        //   "')";
      }

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilter(e.params.$filter, "gajis");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,pegawai,gajis"],
});
/* eslint-disable */
export default {
  components: {
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    // DxItem,
    DxDropDownButton,
    DxValidator,
    DxRequiredRule,
    DxNumericRule,
    DxSummary,
    DxTotalItem,
    DxScrolling,
  },
  setup() {
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const pegawaiStatusStore = usePegawaiStatusStore();
    return {
      pegawaiStatusStore,
      cabangStore,
      unitStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
    };
  },
  data() {
    return {
      filterOperations: ["=", "<>", ">", "<", "between"],
      filterValue: [],
      // filterValue: [["periode_absen", "=", new Date(currentDate)]],
      options: options,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      settingLiburSource: {
        tgl: null,
        direksi: null,
        tetap: null,
        capeg: null,
        honor: null,
        kontrak: null,
      },
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],

      statusGajiSource: [
        { val: true, nama: "Approved" },
        { val: false, nama: "Belum Approved" },
      ],

      numberingPageSize: 50,
      numberingPageNumber: 0,
      dataSource: ds,

      pegawaiStatusSource: null,
      cabangSource: null,
      unitSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      subBidangSource: null,
      seksiSource: null,
      popupLoadingVisible: false,
      popupSettingLiburVisible: false,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },
      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupSettingLiburVisible = false;
        },
      },
      confirmButtonOptions: {
        text: "Simpan",
        onClick: (e) => {
          let result = confirm(
            "<i>Yakin input data? Data Gaji Pegawai akan diubah mengikuti perubahan data absensi.</i>",
            "Konfirmasi"
          );
          result.then((dialogResult) => {
            if (dialogResult) this.settingLibur(e);
          });
        },
      },
    };
  },

  async mounted() {
    this.getUrlFilter();
    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  // watch: {
  //   filterValue: function (newDateValue) {
  //     console.log("filterValue value changed:", newDateValue);

  //     // Perform any other actions you need with the updated date value
  //   },
  // },

  methods: {
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    getUrlFilter() {
      if (this.$route.query.filter) {
        let filter = this.$route.query.filter;
        if (!isNaN(filter[2]) && typeof +filter[2] === "number") {
          filter[2] = parseInt(this.$route.query.filter[2]);
        } else {
        }

        this.filterValue.push(filter);

        if (this.$route.query.filterPeriode !== undefined) {
          let filterPeriode = this.$route.query.filterPeriode;
          filterPeriode[2] = new Date(this.$route.query.filterPeriode[2]);

          this.filterValue.push(filterPeriode);
        }

        return filter;
      } else {
        // this.filterValue.push(["periode_absen", "=", new Date(currentDate)]);
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,
    async settingLibur(e) {
      const result = e.validationGroup.validate();
      if (!result.isValid) return;

      this.settingLiburSource.direksi = this.nullOrZero(
        this.settingLiburSource.direksi
      );
      this.settingLiburSource.tetap = this.nullOrZero(
        this.settingLiburSource.tetap
      );
      this.settingLiburSource.capeg = this.nullOrZero(
        this.settingLiburSource.capeg
      );
      this.settingLiburSource.honor = this.nullOrZero(
        this.settingLiburSource.honor
      );
      this.settingLiburSource.kontrak = this.nullOrZero(
        this.settingLiburSource.kontrak
      );

      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        const response = await axios.post(
          `${API_BASE_URL}/input_libur_massal`,
          this.settingLiburSource,
          config
        );
        notify(response.data.message, response.data.notify_type);
        if (response.data.status) {
          this.refreshDatagrid("dataGrid");
          this.settingLiburSinkronGaji();
        }
      } catch (e) {
        console.log("error", e);
      }
      this.popupSettingLiburVisible = false;
    },
    buttonCan(permiss) {
      // return true;
      if (this.can(permiss)) return true;
      return false;
    },
    settingLiburDialog() {
      this.popupSettingLiburVisible = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },

    onRowUpdating(e) {
      // Prevent the default updating behavior until the async operation is complete
      const event = e;
      const updatedData = { ...e.oldData, ...e.newData };

      e.cancel = new Promise((resolve) => {
        (async () => {
          try {
            // Make the Axios call

            const config = {
              headers: {
                Authorization: api.defaults.headers.common["Authorization"],
                "content-type": "application/json",
              },
            };

            var data = {
              pegawai_id: event.oldData.pegawai_id,
              tgl_gaji: event.oldData.periode_absen,
            };
            const response = await axios.post(
              `${API_BASE_URL}/gaji_approve_get`,
              data,
              config
            );

            // Check the response and decide whether to cancel the update
            if (response.data.data) {
              event.component.cancelEditData();

              notify(
                "Gaji pegawai sudah disetujui, tidak dapat mengubah kehadiran.",
                "error"
              );
              resolve(true); // Cancel the update
            } else {
              // Allow the update
              if (response.data.tidak_hadir !== updatedData.tidak_hadir) {
                await this.saveEditedDataToOData(
                  event.key,
                  event.newData,
                  event.oldData
                );
              }
              // if (e.newData.tidak_hadir !== e.oldData.tidak_hadir) {

              // }
              resolve(false);
            }
          } catch (error) {
            event.component.cancelEditData();
            notify("Gagal mengubah kehadiran.", "error");
            resolve(true); // Cancel the update on error
          }
        })();
      });
    },

    async onRowUpdatingLAMA(e) {
      if (e.newData.tidak_hadir !== e.oldData.tidak_hadir) {
        await this.saveEditedDataToOData(e.key, e.newData, e.oldData);
      }
    },
    async settingLiburSinkronGaji() {
      this.popupLoadingVisible = true;
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        var data = {
          periode_absen: this.settingLiburSource.tgl,
          edited_by_user_id: auth.getUser().id,
        };

        const response = await axios.post(
          `${API_BASE_URL}/input_libur_massal_sinkron_gaji`,
          data,
          config
        );
        notify(response.data.message, response.data.notify_type);
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal sinkron gaji pegawai " + error, "error");
      }
      this.popupLoadingVisible = false;
    },
    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        var data = {
          id: null,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.periode_absen,
          absen_bulan_id: oldData.id,
          changes: null,
          proyeksi: false,
          jml_tdk_masuk: newData.tidak_hadir,
          edited_by_user_id: auth.getUser().id,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data

        notify(response.data.message, response.data.notify_type);

        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update absen/gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },
    formatStatusGaji(method, val) {
      if (
        typeof val === "undefined" ||
        val.data.value === null ||
        !val.data.value
      ) {
        if (method == "icon") return "edit";
        if (method == "type") return "danger";
      }
      if (val.data.value) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
      }

      return;
    },
    setCellValueCuti(newData, value) {
      newData.cuti = value;
    },
    setCellValueAlpa(newData, value, currentRowData) {
      newData.alpa = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.libur);
    },
    setCellValueIjin(newData, value, currentRowData) {
      newData.ijin = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.libur);
    },
    setCellValueLibur(newData, value, currentRowData) {
      newData.libur = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.ijin);
    },
    setCellValueSakit(newData, value, currentRowData) {
      newData.sakit = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.libur);
    },
    nullOrZero(num) {
      if (num === null) return 0;
      return parseInt(num);
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");
      return date.monthLong + " " + date.year;
    },

    editingStart(e) {
      if (
        e.column.dataField === "hadir" ||
        e.column.dataField === "sakit" ||
        e.column.dataField === "ijin" ||
        e.column.dataField === "alpa" ||
        e.column.dataField === "cuti" ||
        e.column.dataField === "libur"
      ) {
        e.cancel = false;
      } else {
        e.cancel = true;
      }
    },

    oneditorpreparing(e) {
      if (e.parentType === "dataRow") {
        // if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        if (e.row.data.gajis !== null) {
          if (e.row.data.gajis.status_gaji) {
            e.editorOptions.disabled = true;
            return;
          }
        }
      }
      if (e.dataField === "periode_absen") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
      if (
        e.parentType === "dataRow" &&
        (e.dataField === "hadir" ||
          e.dataField === "sakit" ||
          e.dataField === "ijin" ||
          e.dataField === "alpa" ||
          e.dataField === "cuti" ||
          e.dataField === "libur")
      ) {
        e.editorOptions.disabled = false;
      } else if (e.parentType === "dataRow") {
        e.editorOptions.disabled = true;
      }

      return;
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Absen Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/") ||
    _.includes(str, "gajis/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

function convertFilter(filter, regVar) {
  // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
  // const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
  const regex = new RegExp(`${regVar}/(\\w+) eq (\\S+)`, "g");
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2})`;
  });
  return outputString;
}
</script>
